<template>
  <div class="navMenu">
    <template v-for="navMenu in navMenus">
        <!-- 最后一级菜单 -->
      <el-menu-item v-if="!navMenu.children || navMenu.children.length == 0"
                    :key="navMenu.permissionId" :data="navMenu" :index="navMenu.url"
                   >
        <i :class="navMenu.icon"></i>
        <span slot="title">{{navMenu.menuName}}</span>
      </el-menu-item>

      <!-- 此菜单下还有子菜单 -->
      <el-submenu v-if="navMenu.children && navMenu.children.length > 0" collapse="true"
                  :key="navMenu.permissionId" :data="navMenu" :index="navMenu.url">
        <template slot="title">
          <i :class="navMenu.icon"></i>
          <span> {{navMenu.menuName}}</span>
        </template>
        <!-- 递归 -->
        <NavMenu :navMenus="navMenu.children"></NavMenu>
      </el-submenu>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'NavMenu',
    props: ['navMenus'],
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style>
</style>